var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MetricTimeSeries',_vm._b({attrs:{"title":_vm.title,"item-id":_vm.itemId,"metric":_vm.metric,"owner-posts":true}},'MetricTimeSeries',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }